__turbopack_context__.v({
  "container": "_41Dh5G_container",
  "promptSuggestion": "_41Dh5G_promptSuggestion",
});
